// extracted by mini-css-extract-plugin
export default {"container":"Publications_container__spyai"};